/** Находим кнопку закрытия балуна и вешаем обработчик клика на нее
 * https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/layout.templateBased.Base.html#method_detail__build
 */
export function buildBalloon(closeSelector) {
  this.constructor.superclass.build.call(this);
  var parent = this.getParentElement();
  this._closeButton = parent.querySelector(closeSelector);
  this._onClose = this.constructor.handleCloseClick.bind(this);
  if (this._closeButton) {
    this._closeButton.addEventListener('click', this._onClose);
  }
}

/** Отписываемся от обработчика клика */
export function clear() {
  if (this._closeButton) {
    this._closeButton.removeEventListener('click', this._onClose);
  }
  this.constructor.superclass.clear.call(this);
}

/** Реализовываем автопозиционирование балуна,
 * чтобы балун всегда оказывался в видимой области карты
 */
export function getShapeBalloon(yInstance, offset) {
  this._element = this._closeButton ? this._closeButton.parentElement : null;
  if (!this._element) {
    return null;
  }
  var coordinates = new yInstance.geometry.pixel.Rectangle([offset, [offset[0] + this._element.offsetWidth, offset[1] + this._element.offsetHeight]]);
  return new yInstance.shape.Rectangle(coordinates);
}

/** Обработчик клика на крестик, который закрывает балун */
export function handleCloseClick() {
  this.events.fire('userclose');
}